import { ACTION_TYPES } from "../actions/room";

const initialState = {
    rooms: [],
    metaRoom: {}
}

export const room = (state = initialState, action) => {
    switch (action.type) {
        case ACTION_TYPES.ROOM_FETCH_ALL:
            return {
                ...state,
                rooms: [...action.payload]
            }
        case ACTION_TYPES.ROOM_CREATE:
            return {
                ...state,
                rooms: [...state.rooms, action.payload]
            }
        case ACTION_TYPES.ROOM_UPDATE:
            return {
                ...state,
                rooms: state.rooms.map(x => x.id === action.payload.id ? action.payload : x)
            }
        case ACTION_TYPES.ROOM_DELETE:
            return {
                ...state,
                rooms:state.rooms.filter(x => x.id !== action.payload)
            }
        case ACTION_TYPES.ROOM_PAGINATION:
         
            return {
                ...state,
                rooms: action.payload.meta.page===1?action.payload.rooms:[...state.rooms, ...action.payload.rooms],
                metaRoom: action.payload.meta
            }
        default:
            return state;
    }
}